import React from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import { PROGRESS_STAGES, statusToStageIndex } from "./accountConstants";

export const ProgressBar = ({ status, compact = false }) => {
  const { t } = useTranslation();
  const rejected = status === "rejected";
  const current = statusToStageIndex(status);

  if (rejected) {
    return (
      <div className="flex items-center gap-2 text-sm text-red-300" data-testid="progress-rejected">
        <span className="h-2.5 w-2.5 rounded-full bg-red-400" />
        {t("account.progress.rejected")}
      </div>
    );
  }

  return (
    <div className={`flex items-center ${compact ? "gap-1" : "gap-2"}`} data-testid="progress-bar">
      {PROGRESS_STAGES.map((stage, idx) => {
        const done = idx < current;
        const active = idx === current;
        return (
          <React.Fragment key={stage}>
            <div className="flex flex-col items-center gap-1">
              <div
                className={`grid place-items-center rounded-full transition-colors ${
                  compact ? "h-4 w-4" : "h-7 w-7"
                } ${
                  done
                    ? "bg-venka-green text-slate-950"
                    : active
                    ? "bg-venka-green-light text-slate-950 ring-4 ring-venka-green-light/20"
                    : "bg-slate-800 text-slate-500"
                }`}
              >
                {done ? (
                  <Check className={compact ? "h-2.5 w-2.5" : "h-4 w-4"} />
                ) : (
                  !compact && <span className="text-xs font-semibold">{idx + 1}</span>
                )}
              </div>
              {!compact && (
                <span className={`text-[11px] ${active || done ? "text-slate-200" : "text-slate-500"}`}>
                  {t(`account.progress.${stage}`)}
                </span>
              )}
            </div>
            {idx < PROGRESS_STAGES.length - 1 && (
              <div className={`h-0.5 flex-1 ${compact ? "min-w-[16px]" : "min-w-[24px] -mt-4"} ${idx < current ? "bg-venka-green" : "bg-slate-800"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressBar;
